import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetCategories_categoryId_ = "/categories/:categoryId";

export type ParamsGetCategories_categoryId_ = ExtractRouteParams<
  typeof RouteGetCategories_categoryId_
>;

export type ResponseGetCategories_categoryId_ = {
  id: number;
  categoryCode: string;
  categoryGroup: string;
  status: "ACTIVE" | "ARCHIVED";
};
